import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import './sass/app.scss'

import axios from 'axios'
import VueAxios from 'vue-axios'
import { global } from './global.js'

Vue.config.productionTip = false

Vue.use(VueAxios, axios)

Vue.axios.defaults.baseURL = `https://api.demobottle.com/`;
Vue.axios.defaults.headers = {
  "Content-Type": "Content-Type:application/json",
  Authorization: "Bearer " + localStorage.token,
};

Vue.prototype.$globals = global;

new Vue({
  router,
  global,
  mounted() {
    //var self = this;
    axios({
      method: "GET",
      crossdomain: true,
      headers: {
        "Content-Type": "Content-Type:application/json",
        Authorization: "Bearer " + localStorage.token,
      },
      url: "/user/me",
    })
      .then(function (response) {
        global.user = response.data;
        global.current_organization = response.data.organizations[0];
      })
      .catch(function (error) {
        console.log(error);
      });

  },
  render: h => h(App)
}).$mount('#app')
